/* eslint-disable no-unused-expressions */
/* eslint-disable radix */
import React, { memo, useState, useEffect } from 'react';
import styles from './ScrollTop.module.less';
import { scrollingDom } from '../../utils/utils';

export default memo(({ node }) => {
  const [visible, setVisible] = useState(false);

  const handleScroll = () => {
    if (node && node.scrollTop > 1500) {
      setVisible(true);
      return;
    }
    setVisible(false);
  };

  const handleScrollToTop = () => {
    let speed = 80;

    if (node && node.scrollTop > 0) {
      if (node.scrollTop > 1000) {
        speed = parseInt(node.scrollTop / 1000) * 50;
      }
      scrollingDom(node, 0, speed);
    }
  };

  useEffect(() => {
    node && node.addEventListener('scroll', handleScroll);
    return () => {
      node && node.removeEventListener('scroll', handleScroll);
    };
  }, [node]);
  if (!visible) {
    return <></>;
  }
  return <div className={styles.scroll_top} onClick={handleScrollToTop}></div>;
});
